import * as React from 'react'

const IconFilter = ({ width = '16px', height = '16px', fill = '#3d3d3d' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 32 32"
  >
    <path stroke={fill} strokeLinecap="round" strokeWidth="2" d="M4 8h24"></path>
    <path stroke={fill} strokeLinecap="round" strokeWidth="2" d="M8 16h16"></path>
    <path stroke={fill} strokeLinecap="round" strokeWidth="2" d="M11 24h10"></path>
  </svg>
)

export default IconFilter
